import { Layer } from 'react-map-gl/mapbox';
import type { ExpressionSpecification } from 'mapbox-gl';
import { defaultSymbolLayerLayoutProps } from '../../utils/layers';

type Props = {
  beforeId: string;
  chevronLayerId: string;
  hide?: boolean;
  opacity?: number;
  sourceId: string;
  symbolSpacing?: number;
  chevronColor?: string;
  useDynamicColor?: boolean;
};

const ChevronLayer = ({ beforeId, chevronLayerId, hide, opacity = 1, sourceId, symbolSpacing = 50, chevronColor, useDynamicColor }: Props) => {
  const iconImage: string | ExpressionSpecification = useDynamicColor
    ? ['concat', 'chevron-', ['slice', ['get', 'lineOutlineColor'], 1]]
    : chevronColor
      ? `chevron-${chevronColor.replace('#', '')}`
      : 'chevron';

  return (
    <Layer
      beforeId={beforeId}
      id={chevronLayerId}
      source={sourceId}
      type="symbol"
      layout={{
        ...defaultSymbolLayerLayoutProps,
        'icon-image': iconImage,
        'icon-rotate': 90,
        'symbol-placement': 'line',
        'symbol-spacing': symbolSpacing,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true,
        visibility: hide ? 'none' : 'visible'
      }}
      paint={{ 'icon-opacity': opacity }}
    />
  );
};

export default ChevronLayer;
